'use strict';

const veil = require('./veil');

var keyboardAccessibility = require('./keyboardAccessibility');
let SCREENSIZE = require('../utilities/constants').SCREENSIZE;

var clearSelection = function (element, immediate) {
    $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
    $(element).closest('.dropdown.show').removeClass('show');

    const removeElements = () => {
        $(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
            .detach();
        $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
        $(element).closest('li').detach();
    }

    if (immediate) {
        removeElements()
        return;
    }

    // Wait for transition to complete, then remove
    const $menuEl = $(element).closest('.dropdown');
    $menuEl.off('transitionend webkitTransitionEnd oTransitionEnd').one('transitionend webkitTransitionEnd oTransitionEnd', removeElements);
};

var clearSelectedMenuClass = function () {
    $('.dropdown-menu').removeClass('show');
    $('body').removeClass('active-bg');
    if ($('.search-wrapper').hasClass('d-none')) {
        veil.remove('body');
    }
    $('.nav-item').removeClass('show');
    $('.dropdown-item').removeClass('show');
    $('.btn--close-container .btn_close').removeClass('invisible');
}

var toggleMenuFlyout = function () {
    $('.main-menu').toggleClass('in');
    $('.main-menu').removeClass('d-none');
    $('.main-menu').attr('aria-hidden', 'false');
    $('.main-menu').siblings().attr('aria-hidden', 'true');
    $('header').siblings().attr('aria-hidden', 'true');
    $('.main-menu .nav.navbar-nav .nav-link').first().focus();
    $('.hamburger-menu-icon').toggleClass('d-none');
    $('.close-icon').toggleClass('d-none');
    if (!$('.main-menu').hasClass('in')) {
        clearSelection($('.main-menu .navbar-nav').find('.back'))
        veil.remove('body');
        $('body').removeClass('overflow-hidden');
    }else {
        veil.add('body');
        $('body').addClass('overflow-hidden');
    }
}

module.exports = function () {
    let mql = window.matchMedia("(min-width: "+ SCREENSIZE.MOBILEMAX +"px)");

    mql.addEventListener('change', event => {
        if (event.matches) {
            // Going to Desktop
            if ($('.main-menu').hasClass('in')) {
                toggleMenuFlyout()
            }
        } else {
            // Going to Mobile
            clearSelectedMenuClass()
        }
    });

    var isDesktop = function () {
        return mql.matches
    };

    var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('d-none');
        window.sessionStorage.setItem('hide_header_banner', '1');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $('.header-banner').removeClass('d-none');
    }

    keyboardAccessibility(
        '.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    if (!(menuItem.next().length > 0)) { // if this is the last menuItem
                        menuItem.parent().parent().find('li > a') // set focus to the first menuitem
                            .first()
                            .focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                } else if (menuItem.prev().length === 0) { // first menuItem
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().children().last().children() // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );

    $('.dropdown:not(.disabled) [data-toggle="dropdown"]')
        .on('click', function (e) {
            e.preventDefault();
            if (!isDesktop()) {
                var closeMenu = $('<li class="back-menu-title"></li>');
                var categoryName = $(this).find('.sub-category-title').length > 0 ? $(this).find('.sub-category-title').html() : $(this).html();
                closeMenu.append($('.close-menu').first().clone());
                closeMenu.find('.close-menu').removeClass('d-none');
                closeMenu.find('.category-name').html(categoryName);
                $(this).parent().children('.dropdown-menu')
                    .prepend(closeMenu)
                    .attr('aria-hidden', 'false');
                // copy navigation menu into view
                $(this).parent().addClass('show');
                $(this).parents('.navbar-nav').removeClass('flex-nowrap');
                $(this).attr('aria-expanded', 'true');
                $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
                e.preventDefault();
            }
            if (isDesktop()) {
                var eventElement = this;
                let currentCategoryL1 = $(this).parent().hasClass('show');
                $('.navbar-nav > li').each(function () {
                    if (!$.contains(this, eventElement)) {
                        if ($(this).hasClass('show')) {
                            $(this).removeClass('show');
                            $(this).attr('aria-expanded', 'false');
                            $(this).children('div.dropdown-menu').removeClass('show');
                            $(this).children('div.dropdown-menu').find('>.dropdown-item').removeClass('show');
                            $(this).children('div.dropdown-menu').find('>.dropdown-item .dropdown-menu').removeClass('show');
                            $(this).children('div.dropdown-menu').find('>.dropdown-item .btn_close').removeClass('invisible');
                            $(this).children('.nav-link').attr('aria-expanded', 'false');
                        }
                    }
                });
                if ($(this).hasClass('sub-category-link') && !$(this).hasClass('sub-category-level-3')) {
                    $(this).closest('.dropdown-menu').children('.dropdown-item').removeClass('show');
                    $(this).parents().siblings('.dropdown-item.dropdown.show').find('a').attr('aria-expanded', 'false');
                    $(this).parents().siblings('.dropdown-item.dropdown').removeClass('show');
                    $(this).closest('.dropdown-menu').find('.dropdown-item .dropdown-menu').removeClass('show');
                }
                // need to close all the dropdowns that are not direct parent of current dropdown
                if (!currentCategoryL1) {
                    $(this).parent().addClass('show');
                    $(this).siblings('.dropdown-menu').addClass('show');
                    $(this).siblings('.dropdown-menu').removeAttr('inert');
                    $(this).attr('aria-expanded', 'true');
                    $(this).closest('body').addClass('active-bg');
                    // $(this).closest('body').find('.bg-block').addClass('active');
                    veil.add('body');
                    if ($(this).hasClass('sub-category-link') && !$(this).hasClass('sub-category-level-3')) {
                        $(this).closest('.dropdown-menu').find('>.btn--close-container .btn_close').addClass('invisible');
                    }
                } else if (!$(this).hasClass('sub-category-level-3')) {
                    clearSelectedMenuClass();
                    $('.dropdown-menu').attr('inert', 'true');
                    $(this).attr('aria-expanded', 'false');
                }
                
                if ($('.dropdown-menu').hasClass('show')) {
                    $('body').addClass('overflow-hidden');
                } else {
                    $('body').removeClass('overflow-hidden');
                }
            }
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        $('.menu-toggleable-left').removeClass('in');
        $('.navbar-toggler').focus();
        $('.main-menu').attr('aria-hidden', 'true');
        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        $(this).parents('.navbar-nav').addClass('flex-nowrap');
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        $('.menu-toggleable-left').removeClass('in');

        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');

    });

    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        $(this).parent().siblings('.menu-toggleable-left').find('.navbar-nav').addClass('flex-nowrap');
        toggleMenuFlyout();
        $('.dropdown-menu').removeAttr('inert');
    });

    keyboardAccessibility(
        '.navbar-header .user',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function () { // escape
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            },
            9: function () { // tab
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            }
        },
        function () {
            var $popover = $('.user .popover li.nav-item');
            return $popover;
        }
    );

    $('.navbar-header .user').on('click', function () {
        var popover = $('.account-flyout .popover');
        if (popover.length) {
            popover.find('.container').removeClass('d-none');
            popover.addClass('show').removeAttr('inert');
            $('.modal-background').show();
            popover.find('.account-flyout-header .close').focus();
            $('body').addClass('overflow-hidden');
        }
    });

    $('.account-flyout-header .close, .modal-background').on('click', function () {
        var popover = $('.account-flyout .popover');
        popover.removeClass('show');
        $('.modal-background').hide();
        $('body').removeClass('overflow-hidden');
        popover.find('.container').addClass('d-none');
        $(this).closest('.account-flyout').siblings('header').find('.user-icon .user').focus();
    }); 

    $('body').on('click', '#myaccount', function (event) {
        event.preventDefault();
    });


    $('body').on('click', function (e) {
        if ($(e.target).parents('.dropdown-menu').length <= 0) {
            if ($(e.target).parents('.navbar-nav').length <= 0 && $('.navbar-nav .dropdown-menu').hasClass('show')) {
                clearSelectedMenuClass();
                if ($('.search-wrapper').hasClass('d-none')) {
                    $('body').removeClass('overflow-hidden');
                }
            }
        }
    });

    $('.btn--close-container .btn_close').on('click', function () {
        clearSelectedMenuClass();

        if (isDesktop()) {
            $('.dropdown-menu').attr('inert', 'true');
            $(this).closest('.dropdown').children('.nav-link').attr('aria-expanded', 'false');
            $(this).closest('li.nav-item').find('a.nav-link').focus();             
        }
    });

    $('body').on('touchstart', function (e) {
        if ($(e.target).parents('.main-menu').length <= 0 && (!$(e.target).hasClass('close-icon') && !$(e.target).hasClass('navbar-toggler'))) {
            if (!$('.main-menu').is(e.target) && $('.main-menu').hasClass('in')) {
                toggleMenuFlyout();
            }
        }
    });

    $('.js-focus-maincontent').on('click', function () {
        $('#maincontent').attr('tabindex', '-1').focus();    
    });
    
    $('.js-focus-footercontent').on('click', function () {
        $('#footercontent').attr('tabindex', '-1').focus();    
    });
};